<div class="slider">
  <div class="slider-item" [@imageChange]="currentDirection" *ngIf="activeSlide === 1">
    <div class="slider-heading">Never miss a deadline with<br />VComply’s automatic alerts!</div>
    <div class="slider-info">
      <img class="base-line" src="./assets/images/base-line.svg" alt="Base-line" />
      <img class="sl-1-letter" src="./assets/images/letter.svg" alt="Letter" />
      <img class="sl-1-email" src="./assets/images/email-box.svg" alt="Email" />
      <div class="comment-box">
        <img class="sl-1-comment" src="./assets/images/message-box.svg" alt="Message" />
        <img class="sl-1-bell" src="./assets/images/notification-bell.svg" alt="Notification" />
      </div>
      <img class="sl-1-sun" src="./assets/images/message-alert.svg" alt="Messages" />
      <div class="sl-1-left-arrow">
        <img src="./assets/images/left-arrow.svg" alt="Arrow" />
      </div>
      <div class="sl-1-right-arrow">
        <img src="./assets/images/right-arrow.svg" alt="Arrow" />
      </div>
      <div class="sl-1-checkbox">
        <img src="./assets/images/tasks-grey.svg" alt="Task" />
        <img class="sl-1-checkone" src="./assets/images/tick.svg" alt="Tick" />
        <img class="sl-1-checktwo" src="./assets/images/tick.svg" alt="Tick" />
      </div>
    </div>
  </div>
  <div class="slider-item" [@imageChange]="currentDirection" *ngIf="activeSlide === 2">
    <div class="slider-heading">Setup your holidays and track your<br />work using VComply’s Calendar.</div>
    <div class="slider-info">
      <img class="base-line" src="./assets/images/base-line.svg" alt="Base" />
      <div class="sl-2-calendar">
        <img class="calendar" src="./assets/images/calendar-2.svg" alt="Calander" />
        <img class="sl-yellow-1" src="./assets/images/yellow-bg.svg" alt="Yellow" />
        <img class="sl-yellow-2" src="./assets/images/yellow-bg.svg" alt="Yellow" />
        <img class="sl-green-1" src="./assets/images/available-tick.svg" alt="Tick" />
        <img class="sl-green-2" src="./assets/images/available-tick.svg" alt="Tick" />
        <img class="sl-red-1" src="./assets/images/unavailable-close.svg" alt="Close" />
        <img class="sl-red-2" src="./assets/images/unavailable-close.svg" alt="Close" />
        <div class="not-date-1"></div>
        <div class="not-date-2"></div>
        <img class="sl-large-tick" src="./assets/images/large-tickmark.svg" alt="Tick" />
      </div>
      <img class="sl-2-clock" src="./assets/images/clock-2.svg" alt="Clock" />
      <img class="sl-2-umbrella" src="./assets/images/umbrella.svg" alt="Umbrella" />
      <div class="sl-2-wheel">
        <img src="./assets/images/cog-wheel.svg" alt="Wheel" />
      </div>
      <div class="sl-3-paper">
        <div class="sl-3-paper-inner">
          <ul>
            <li><img src="./assets/images/task-y.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-g.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-gr.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-b.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-g.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-r.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-y.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-g.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-gr.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-b.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-g.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-r.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-y.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-g.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-gr.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-b.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-g.svg" alt="Task" /></li>
            <li><img src="./assets/images/task-r.svg" alt="Task" /></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="slider-item" [@imageChange]="currentDirection" *ngIf="activeSlide === 3">
    <div class="slider-heading">Always be up to date with intuitive<br />insights and KPIs.</div>
    <div class="slider-info">
      <img class="base-line" src="./assets/images/base-line.svg" alt="Baseline" />
      <div class="sl-3-bg"></div>
      <div class="sl-3-lady">
        <img class="sl-lady" src="./assets/images/lady.svg" alt="Lady" />
        <div class="sl-paper">
          <img class="" src="./assets/images/paper.svg" alt="paper" />
          <div class="sl-paper-bar-1"></div>
          <div class="sl-paper-bar-2"></div>
          <div class="sl-paper-bar-3"></div>
          <div class="sl-paper-bar-4"></div>
          <img class="sl-paper-comment" src="./assets/images/details.svg" alt="details" />
        </div>
      </div>
      <div class="sl-3-setting">
        <img src="./assets/images/cogwheel.svg" alt="Wheel" />
      </div>
      <div class="clock">
        <img src="./assets/images/clock.svg" alt="Clock" />
      </div>
      <img class="sl-3-tree" src="./assets/images/plant.svg" alt="Plant" />
    </div>
  </div>

  <div class="slider-dot">
    <button (click)="activeSlide = i + 1" [class.active]="activeSlide === i + 1" *ngFor="let button of [1, 2, 3]; let i = index"></button>
  </div>
</div>
